<template>
  <div class="s-setting-container">
    <div class="main-header">
      <div>Shipping Addresses</div>
      <div v-if="adminRole === 'admin'">
        <button
          type="button"
          class="save-btn"
          @click="toggleActionModal(true, 'edit-address', {})"
        >
          <v-icon
            color="#4979FF"
            dark
            medium
          >
            mdi-plus
          </v-icon>
          Add new
        </button>
      </div>
    </div>
    <ShippingAddress
      :shippingAddresses="shippingAddresses"
      :editAddress="(address) => toggleActionModal(true, 'edit-address', address)"
      :deleteAddress="(address) => toggleActionModal(true, 'delete-address', address)"
    />
    <AddressModal
      type="SHIPPING"
      :show="showModal"
      :view="modalView"
      :toggle="toggleActionModal"
      :address="address"
      :states="states"
      :update="update"
    />
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import ShippingAddress from '@shared/components/partnerSettings/ShippingAddress.vue';
import AddressModal from './shippingModal/AddressModal.vue';

export default {
  name: 'ShippingAddressSection',
  components: {
    ShippingAddress,
    AddressModal,
  },
  mixins: [partnerSettingsMixin],
  props: {
    shippingAddresses: Array,
    update: Function,
    states: Array,
  },
  data() {
    return {
      address: {},
      showModal: false,
      modalView: '',
    };
  },
  methods: {
    handleChange(field, value) {
      if (field === 'address') {
        Object.keys(value).forEach((k) => {
          if (this[k] !== undefined) {
            this[k] = value[k];
          }
        });
      } else {
        this[field] = value;
      }
    },
    toggleActionModal(show, view, address) {
      this.showModal = show;
      if (show) {
        this.modalView = view;
        this.address = address;
      } else {
        this.address = {};
      }
    },
  },
};
</script>
